import type { Permission } from '@softfactura/shared';

/** Importurile pe categorii din „Import date” = valorile lui `?tip=` (aceleași chei ca rândurile din pagină). */
export type ImportKey = 'stocuri' | 'clienti' | 'furnizori' | 'produse' | 'produse-clienti' | 'facturi-trimise' | 'facturi-xml';

/**
 * Drepturile cerute de server pentru importurile din „Import date” (`/setari?tab=migrare`; `/migrare?tip=…` duce acolo).
 * Importul nu are un drept al lui: fiecare import cere dreptul de creare al datelor pe care le scrie (la o listă,
 * oricare dintre ele). Un rând nou din pagină fără cheie aici nu compilează (altfel ar dispărea pentru toți).
 */
export const DREPT_IMPORT: Record<ImportKey, Permission[]> = {
  stocuri: ['stock.adjust'], // POST /stock/import/*
  clienti: ['clients.create'], // POST /clients
  furnizori: ['clients.create'], // POST /clients (furnizorii stau tot în clients)
  produse: ['products.create'], // POST /products
  // „Import Produse / Clienți” din /facturi: deschide importul de clienți, iar fără drept pe clienți, pe cel de produse
  'produse-clienti': ['clients.create', 'products.create'],
  'facturi-trimise': ['efactura.submit'], // POST /efactura/import-sent/*
  'facturi-xml': ['efactura.submit'], // POST /efactura/import-xml/*
};

/** Drepturile importului dintr-un `?tip=` venit din adresă; `undefined` = tip necunoscut. */
export function dreptPentruImport(tip: string): Permission[] | undefined {
  return Object.prototype.hasOwnProperty.call(DREPT_IMPORT, tip) ? DREPT_IMPORT[tip as ImportKey] : undefined;
}

/** Migrarea de pe alt program (SmartBill, Oblio…): MigrationV2Controller cere `billing.manage`. */
export const DREPT_IMPORT_PLATFORMA: Permission = 'billing.manage';

/** Importurile pe categorii (secțiunea „Ce vrei să imporți?”): oricare dintre drepturile lor. */
export const DREPT_IMPORT_CATEGORII: Permission[] = Array.from(new Set<Permission>(Object.values(DREPT_IMPORT).flat()));

/** „Import date” se deschide cu oricare dintre drepturile importurilor de acolo (un cont doar de citire nu are niciunul). */
export const DREPT_PAGINA_IMPORT: Permission[] = Array.from(new Set<Permission>([DREPT_IMPORT_PLATFORMA, ...DREPT_IMPORT_CATEGORII]));
